module.exports = __webpack_public_path__ + "img/logo-hw2.995f4461.png";